import {
  NEW_CUSTOMER_TAG,
  NEW_CUSTOMER_TAG_SUCCESS,
  NEW_CUSTOMER_TAG_FAIL,
} from "./actionTypes";

const initialState = {
  loading: false,
  message: null,
  error: null,
  data: null,
  newTag: null,
};

const newCustomerTag = (state = initialState, action) => {
  switch (action.type) {
    case NEW_CUSTOMER_TAG:
    case NEW_CUSTOMER_TAG_SUCCESS:
    case NEW_CUSTOMER_TAG_FAIL:
      state = {
        ...state,
        ...action.payload,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default newCustomerTag;
